import CreateVMISLPRepositoryImpl from './impl/CreateVMISLPRepositoryImpl'

export default {
  getInstance () {
    return new CreateVMISLPRepositoryImpl()
  }
}
